import { Tag } from 'antd';
import type { DriverDetail } from '../drivers.api';
import { AVAILABILITY_COLORS, AVAILABILITY_LABELS } from '../policies/availability-labels';

/** Read-only on purpose: availability follows trips and employment status, so there is nothing to edit here (gitaumoses4/chukua#54). */
export function DriverAvailabilityPanel({ availability }: Pick<DriverDetail, 'availability'>) {
  return (
    <section aria-label="Availability" className="rounded-lg border border-line bg-surface px-4 py-3">
      <p className="text-sm font-medium text-fg">Availability</p>
      <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted">
        <Tag className="m-0" color={AVAILABILITY_COLORS[availability.status]}>
          {AVAILABILITY_LABELS[availability.status]}
        </Tag>
        <span>since {new Date(availability.since).toLocaleString()}</span>
        {availability.lastTripEndAt && <span>Last trip ended {new Date(availability.lastTripEndAt).toLocaleString()}</span>}
      </p>
    </section>
  );
}
